import HomePage from './views/Home';
import IntroPage from './views/Intro';
import Stage1IntroPage from './views/Stage1Intro';
import Stage1SelectPage from './views/Stage1Select';
import Stage1ConfirmPage from './views/Stage1Confirm';
import Stage1GamePage from './views/Stage1Game';
import Stage1ResultPage from './views/Stage1Result';
import Stage2IntroPage from './views/Stage2Intro';
import Stage2GamePage from './views/Stage2Game';
import Stage2ResultPage from './views/Stage2Result';
import FinalResultPage from './views/FinalResult';
import MorePage from './views/More';

export default [
    { name: 'home-page', path: '/', exact: true, Component: HomePage },
    { name: 'intro-page', path: '/intro', Component: IntroPage },
    { name: 'stage1-intro-page', path: '/stage1-intro', Component: Stage1IntroPage },
    { name: 'stage1-select-page', path: '/stage1-select', Component: Stage1SelectPage },
    { name: 'stage1-confirm-page', path: '/stage1-confirm', Component: Stage1ConfirmPage },
    { name: 'stage1-game-page', path: '/stage1-game', Component: Stage1GamePage },
    { name: 'stage1-result-page', path: '/stage1-result', Component: Stage1ResultPage },
    { name: 'stage2-intro-page', path: '/stage2-intro', Component: Stage2IntroPage },
    { name: 'stage2-game-page', path: '/stage2-game', Component: Stage2GamePage },
    { name: 'stage2-result-page', path: '/stage2-result', Component: Stage2ResultPage },
    { name: 'final-result-page', path: '/final-result', Component: FinalResultPage },
    { name: 'more-page', path: '/more', Component: MorePage }
];